module.exports = __webpack_public_path__ + "img/f5317c7.png";